import React                from 'react';

import * as UserType        from '../shared/types/User';
import dayjs                from '../shared/utils/day-timezone';

import InfiniteTable        from '../components/InfiniteTable';
import intelitransit        from '../utils/InteliTransit';
import MenuItem             from '../components/MenuItem';
import * as images          from '../images';

class UsersTable extends InfiniteTable<UserType.Hydrated> {
    fetchRows( orderby:string, limit:number, skip:number ) {
        return this.getTablePromise<UserType.Dehydrated[]>('/api/manager/users','GET',undefined,{orderby,limit,skip})
            .then( payload => {
                return payload.map(UserType.hydrate);
            })
    }
    renderThead() {
        return (
            <tr>
                <th>Picture</th>
                <th onClick={()=>this.sort('createdAt')}>{this.getSortingIcon('createdAt')}Created</th>
                <th onClick={()=>this.sort('updatedAt')}>{this.getSortingIcon('updatedAt')}Updated</th>
                <th onClick={()=>this.sort('lastLoginAt')}>{this.getSortingIcon('lastLoginAt')}Last Login</th>
                <th onClick={()=>this.sort('idProvider')}>{this.getSortingIcon('idProvider')}Provider</th>
                <th onClick={()=>this.sort('lname')}>{this.getSortingIcon('lname')}Name</th>
                <th onClick={()=>this.sort('emailAddress')}>{this.getSortingIcon('emailAddress')}Email Address</th>
            </tr>
        )
    }
    renderRow( user:UserType.Hydrated ) {
        return (
            <tr key={user._id} style={{ verticalAlign:'top'}}>
                <td style={{ verticalAlign:'top'}}>
                    <img width={100} alt={user._id} src={`${user.picture}?${Date.now()}`}/>
                </td>
                <td style={{ verticalAlign:'top'}}>
                    {dayjs(user.createdAt).tz(intelitransit.agency.timeZone).format(intelitransit.timeFormat)}
                </td>
                <td style={{ verticalAlign:'top'}}>
                    {dayjs(user.updatedAt).tz(intelitransit.agency.timeZone).format(intelitransit.timeFormat)}
                </td>
                <td style={{ verticalAlign:'top'}}>
                    {user.lastLoginAt ? dayjs(user.lastLoginAt).tz(intelitransit.agency.timeZone).format(intelitransit.timeFormat) : "n/a"}
                </td>
                <td style={{ verticalAlign:'top'}}>
                    {user.idProvider}
                </td>
                <td style={{ verticalAlign:'top'}}>
                    {[user.fname,user.lname].filter(n=>!!n).join(" ")}
                </td>
                <td style={{ verticalAlign:'top'}}>
                    {user.emailAddress}
                </td>
            </tr>
        )
    }
}

export const Users : React.FC<{}> = props => {
    return (
        <MenuItem title={["Users",<a key='download' href='/api/manager/users?csv'><images.Download/></a>]}>
            <UsersTable/>
        </MenuItem>
    );
}

export default Users;